import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retriveHelps() {
      try {
        const helps = await axios.get('/helps', { withCredentials: true });
        return helps.data;
      } catch (error) {
        throw error;
      }
    },
    async retriveHelpsByCategory(context, category) {
      try {
        const helps = await axios.get(`/helps/${category}`, { withCredentials: true });
        return helps.data;
      } catch (error) {
        throw error;
      }
    },
    async createHelp(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.post('/helps', data, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async updateHelp(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.patch(`/helps/${data.id}`, data.data, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async deleteHelp(context, id) {
      try {
        const config = { withCredentials: true };
        const response = await axios.delete(`/helps/${id}`, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
